import { CONSTANTS } from "../../../constants";

export function getDiscussAndDemonstrateHeaderTitle(bqStep: string): string {
  return `${bqStep}: ${CONSTANTS.BUILD_QUALITY_STEP_TITLES[bqStep as keyof typeof CONSTANTS.BUILD_QUALITY_STEP_TITLES]}`;
}
